import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import { LockOpen } from '@mui/icons-material';
import { motion } from 'framer-motion';
import axiosInstance from '../services/axiosInstance';
import { toast, ToastContainer } from 'react-toastify';

const UnlockDoor = () => {
  const [loading, setLoading] = useState(false);
  const doorId = '67bded1e45e305415765d762'; // Reemplaza con el ID de la puerta

  const unlockDoor = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post('/access/doors/unlock', {
        doorId,
      });
      if (response) {
        toast.success(
          'Puerta abierta. Quizas tengas que esperar unos segundos.'
        );
      }
    } catch (error) {
      console.error('Error unlocking door:', error);
      toast.error('No se pudo abrir la puerta. Inténtalo de nuevo.');
    }
    setLoading(false);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#f4f6f8"
      padding={2}
    >
      <ToastContainer />
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          component="img"
          src="logo.png" // Reemplaza con la ruta correcta del logo
          alt="Logo"
          sx={{ width: 100, height: 'auto', marginBottom: 3 }}
        />
      </motion.div>

      <Paper
        elevation={3}
        sx={{
          padding: 4,
          textAlign: 'center',
          width: '100%',
          maxWidth: 400,
          boxShadow: 3,
          bgcolor: 'white',
        }}
      >
        <Typography variant="h5" color="primary" gutterBottom>
          Acceso a la puerta
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Pulsa el botón solo cuando estés frente a la puerta.
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <Button
            variant="contained"
            color="success"
            startIcon={<LockOpen />}
            onClick={unlockDoor}
          >
            Abrir puerta
          </Button>
        )}
      </Paper>
    </Box>
  );
};

export default UnlockDoor;
